import React, {useEffect, useState} from "react";
import {Alert, Button} from "@mui/material";
import {useTranslation} from "react-i18next";
import {useSearchParams} from "react-router-dom";
import useOrderConfirmation, {isConfirmationResolved} from "./use-order-confirmation";
import OrderConfirmationDialog from "../../dialog/order-confirmation-dialog";

export default function OrderConfirmationEntry({lineId, active, onRefresh, orderStatus}) {
    const {t} = useTranslation(), [open, setOpen] = useState(false);
    const review = useOrderConfirmation({open: active, lineId, orderStatus});
    useEffect(() => {
        // Defer parent reloads while its nested dialog owns a decision or an ambiguous retry.
        if (active && !open && review.refreshRequired) { onRefresh?.(review.data); }
    }, [active, open, review.data, review.refreshRequired, onRefresh]);
    if (!active) return null;
    if (review.error) return <Alert severity="warning" action={<Button onClick={review.refresh}>{t("Retry")}</Button>}>{t(review.error)}</Alert>;
    if (!review.data) return null;
    return <><Alert severity="info" sx={{my: 2}} action={<Button onClick={() => setOpen(true)}>{t("ConfirmationReview")}</Button>}>
        {t(`ConfirmationState${review.data.state}`)}
    </Alert><OrderConfirmationDialog key={review.data.proposalId} open={open} proposalId={review.data.proposalId}
        onClose={view => {setOpen(false); review.refresh(); if (isConfirmationResolved(view)) onRefresh?.(view);}}/></>;
}

export function OrderConfirmationLink() {
    const [params, setParams] = useSearchParams();
    const id = params.get("approval");
    if (!id) return null;
    return <OrderConfirmationDialog key={id} open proposalId={id} onClose={() => {
        const next = new URLSearchParams(params); next.delete("approval"); setParams(next, {replace: true});
    }}/>;
}
